import React from "react";
import { Link } from "react-router-dom";

export const Error404: React.FC = () => (
  <div className="page404">
    <h1>404 <small>page not found</small></h1>
    <p>Sorry, but this page not exists. Please go to homepage or try another URL.</p>
    <Link to="/">Go to MainPage</Link>
  </div>
)